import AboutSection from '../../sections/AboutSection/AboutSection';
import HeroSection from '../../sections/HeroSection/HeroSection';
import ProjectsSection from '../../sections/ProjectsSection/ProjectsSection';
import ContactSection from '../../sections/ContactSection/ContactSection';

const Sections = () => {
    return (
        <>
            <HeroSection />
            <AboutSection />
            <ProjectsSection />
            <ContactSection />
        </>
    );
};

export default Sections;
